/**
 * Created by r4zi4l on 13.01.2021
 */

const Merge2UnitsLibraryWindow = Prefab.createWindow(
    "units_library",
    "unitslibrary_window_prefab_json",
    { bundles: ["unitslibrarywindow"] }
);